// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"3b53517f","101":"3b53517f","138":"3b53517f","479":"3b53517f","625":"3b53517f","702":"3b53517f","761":"3b53517f"}[chunkId] + ".chunk.css";
};